import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=512ec682&scoped=true&"
import script from "./SearchHeader.vue?vue&type=script&lang=js&"
export * from "./SearchHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SearchHeader.vue?vue&type=style&index=1&id=512ec682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ec682",
  null
  
)

export default component.exports